import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Charity, SplitScreen, SplitScreenSectionsTypes } from '@domains';
import { FxFlexDirective, FxLayoutAlignDirective, FxLayoutDirective } from '@rspl-ui';
import { StarRatingModule } from 'angular-star-rating';

import { FxLayoutGapDirective } from '../../flex-layout/fx-layout-gap.directive';
import { Responsive, ResponsiveService } from '../../responsive';
import { CharitySponsoredSectionComponent } from './sections/charity-sponsored/charity-sponsored.component';
import { CustomerServiceSectionComponent } from './sections/customer-service/customer-service.component';
import { ExtraMileSectionComponent } from './sections/extra-mile/extra-mile.component';
import { FaqSectionComponent } from './sections/faq/faq.component';
import { PartnersSectionComponent } from './sections/partners/partners.component';
import { ReviewsSectionComponent } from './sections/reviews/reviews.component';
import { UberSectionComponent } from './sections/uber/uber.component';
import { VeteransBehindResupplySectionComponent } from './sections/veterans-behind-resupply/veterans-behind-resupply.component';
import { WhyChooseResupplySectionComponent } from './sections/why-choose-resupply/why-choose-resupply.component';

@Component({
  selector: 'rspl-split-screen-v4',
  templateUrl: './split-screen-v4.component.html',
  styleUrl: './split-screen-v4.component.scss',
  imports: [FxLayoutDirective, FxLayoutAlignDirective, FxLayoutGapDirective, FxFlexDirective, MatIcon, StarRatingModule, CommonModule],
})
export class SplitScreenV4Component extends Responsive implements OnInit {
  @Input() charity: Charity;
  @Input() config: SplitScreen;
  @Input() goToPrimary: (section: string) => void;
  @Input() goToFree: () => void;

  preview = false;

  get configToUse() {
    if (this.preview) {
      return this.config;
    }
    return this.charity.meta;
  }

  constructor(public override responsiveService: ResponsiveService) {
    super(responsiveService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.preview = new URLSearchParams(window.location.search).get('isPreview') === 'true';
  }

  goToPrimaryAction(section: string) {
    return this.preview ? () => {} : this.goToPrimary(section);
  }

  goToFreeAction() {
    return this.preview ? () => {} : this.goToFree();
  }

  sectionInputs(type: SplitScreenSectionsTypes) {
    const options = this.preview ? this.config?.sections[type]?.options : this.charity?.meta?.sections[type]?.options;
    const inputs = {
      goToPrimary: this.goToPrimaryAction.bind(this),
      goToFree: this.goToFreeAction.bind(this),
      sectionType: type,
      options: options,
    };

    return inputs;
  }

  sectionComponents(type: SplitScreenSectionsTypes) {
    switch (type) {
      case SplitScreenSectionsTypes.uber:
        return UberSectionComponent;
      case SplitScreenSectionsTypes.why:
        return WhyChooseResupplySectionComponent;
      case SplitScreenSectionsTypes.charity:
        return CharitySponsoredSectionComponent;
      case SplitScreenSectionsTypes.review:
        return ReviewsSectionComponent;
      case SplitScreenSectionsTypes.veterans:
        return VeteransBehindResupplySectionComponent;
      case SplitScreenSectionsTypes.faq:
        return FaqSectionComponent;
      case SplitScreenSectionsTypes.partners:
        return PartnersSectionComponent;
      case SplitScreenSectionsTypes.extraMile:
        return ExtraMileSectionComponent;
      case SplitScreenSectionsTypes.customerService:
        return CustomerServiceSectionComponent;
    }
  }
}
